<template>
  <div class="reports__panel--region">
    <div class="region-override">
      <b-field label="Region" class="region">
        <region-dropdown :sourceList="regions"
                        @selectionChanged="(region) => { this.chosenRegion = region; this.$emit('selectionChanged', region); }"
                        :keyPropertyName="(o) => o.id"
                        :displayPropertyName="(o) => o.name"
                        :selectedValue="region"> <!-- v-bind:value="region" -->
        </region-dropdown>
      </b-field>
    </div>
  </div>
</template>

<script>
import RegionDropdown from '@/components/scheduler/schedule/controls/RegionDropdown.vue';
import { mapActions, mapGetters } from "vuex";

export default {
  name: 'reports-panel-region',
  components: { RegionDropdown },
  props: {
    region: {
      type: String,
      default: undefined
    }
  },
  data: () => ({
    chosenRegion: ''
  }),
  async mounted() {
    await this.$store.dispatch('metadata/initialize'); 
    this.chosenRegion = this.region;
  },
  computed: {  
    ...mapGetters('metadata', ['regions']),
  },
  watch: {
    'region'(newValue){
      if(this.region !== newValue){
        this.chosenRegion = newValue
      }
    }
  }
}
</script>

<style lang="scss">
.reports__panel--region {
  & .label {
    padding-left: 5px;
  }
  .ctrl-button {
    padding-left: 9px !important;
  }
}
</style>
